export class SlaCutoff {
	slaCutoffId: number;
	serviceModeId: number | null;
	slaCutoffTime: any;
}
